import { Button, Modal } from '@bp/ui-components';
import dayjs from 'dayjs';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useTeachingBlockStore } from '../../Contexts/TeachingBlockContext';
import styles from './TimeConflictModal.module.scss';

export const TimeConflictModal = observer(() => {
  const { t } = useTranslation();

  const store = useTeachingBlockStore();

  const isSchoolYearEnd = !!store.timeConflictModal.holidayUuids?.find((uuid) => uuid === 'school-year-end-indicator');

  const holidayConflicts = store.timeConflictModal.holidayUuids?.map((uuid) => store.holidays.get(uuid)) ?? [];

  return (
    <Modal
      width='s'
      title={
        isSchoolYearEnd
          ? t('teachingBlockVersion.timeConflict.schoolYearEnd')
          : t('teachingBlockVersion.timeConflict.found')
      }
      isOpen={store.timeConflictModal.isOpen ?? false}
      onRequestClose={store.abortTimeConflict}
      hideCloseButton
      shouldCloseOnEsc={false}
      shouldCloseOnOverlayClick={false}
      parent={document.fullscreenElement ? document.getElementById('teaching-block-grid') : null}
      className={styles['time-conflict-modal']}
    >
      {isSchoolYearEnd ? (
        <div className='mb-6'>{t('teachingBlockVersion.timeConflict.schoolYearEndHint')}</div>
      ) : (
        <div className={styles.conflicts}>
          <div className='mb-2'>{t('teachingBlockVersion.timeConflict.conflicts')}</div>
          {holidayConflicts.map((conflict, i) => {
            return (
              <div key={i} className={styles.conflict}>
                {`${conflict?.name} (${dayjs(conflict?.start).format('DD.MM.YY')} - ${dayjs(conflict?.end).format('DD.MM.YY')})`}
              </div>
            );
          })}
          {/* {teachingBlockConflicts.map((conflict, i) => {
            const card = conflict[0];
            return (
              <div key={i} className={styles.conflict}>
                {`${card?.label} (${dayjs(card?.startDate).format('DD.MM.YY')} - ${dayjs(card?.endDate).format('DD.MM.YY')})`}
              </div>
            );
          })} */}
          <div className='mt-5 mb-2'>{t('teachingBlockVersion.timeConflict.planned')}</div>
          <div
            className={styles.conflict}
          >{`${store.timeConflictModal.card?.label} (${dayjs(store.timeConflictModal.start).format('DD.MM.YY')} - ${dayjs(store.timeConflictModal.end).format('DD.MM.YY')})`}</div>
        </div>
      )}

      <div>{t('common.howToSolve')}</div>
      <div className={styles.actions}>
        <Button className='mr-3' hierarchy='secondary' onClick={() => store.ignoreTimeConflict()}>
          {t('teachingBlockVersion.timeConflict.ignore')}
        </Button>
        {!isSchoolYearEnd && (
          <Button className='mr-3' hierarchy='secondary' onClick={() => store.splitTimeConflict()}>
            {t('teachingBlockVersion.timeConflict.split')}
          </Button>
        )}
        <Button hierarchy='secondary' onClick={() => store.abortTimeConflict()}>
          {t('teachingBlockVersion.timeConflict.abort')}
        </Button>
      </div>
    </Modal>
  );
});
